import { deepMerge } from '@empathybroker/deep-merge';
import { ConfigState, EmpathyXConfig } from '../../../models';
import { DeepPartial } from '../../../utils';
import { CONFIG_MUTATIONS_KEYS } from '../config.const';
import { ConfigMutation } from '../config.interfaces';

export class SetConfigMutation implements ConfigMutation {
  mutations = {
    [CONFIG_MUTATIONS_KEYS.setConfig]: (configState: ConfigState, newConfig: DeepPartial<EmpathyXConfig>) => {
      deepMerge(configState.config[configState.device], newConfig);
    }
  };
}
